import { ModelInfo } from '@core/model/modelInfo.model';
import { ItemInformationModel } from './itemInformation.model';

export class ShoppingCartLineModel {
    ShoppingCartId: number;
    Id: number;
    SiteId: string;
    Item: ItemInformationModel[];
    Quantity: number;
    DiscountPercent: number;
    Price: number;
    PriceUnit: number;
    DiscountPrice: number;
    NetPrice: number;
    TaxAmount: number;
    ConfiguratedProduct: boolean;
    CuponesPercent: number;
    DiscCuponAmount: number;
    DetalleLinea: string;
    TipoProduccion: string;
    Model: ModelInfo;
    ActionId: number;
    Disponible: number;
    CantDiasReabastece: number;
    TiempoProd: number; 
    TieneBRC: boolean;
    UpdConfigSiteLine: boolean;
    Ancho1: number;
    Alto1: number;
    Ancho2: number;
    Alto2: number;
    SoloCotiza: boolean;

    constructor() {
        this.ShoppingCartId = 0;
        this.Id = 0;
        this.SiteId = '';
        this.Item = [];
        this.DiscountPercent = 0;
        this.Price = 0;
        this.PriceUnit = 0;
        this.DiscountPrice = 0;
        this.NetPrice = 0;
        this.TaxAmount = 0;
        this.ConfiguratedProduct = false;
        this.CuponesPercent = 0;
        this.DiscCuponAmount = 0;
        this.DetalleLinea = '';
        this.TipoProduccion = '';
        this.Model = new ModelInfo();
        this.ActionId = 0;
        this.Disponible = 0;
        this.CantDiasReabastece = 0;
        this.TiempoProd = 0;
        this.TieneBRC = false;
        this.UpdConfigSiteLine = false;
        this.Ancho1 = 0;
        this.Alto1 = 0;
        this.Ancho2 = 0;
        this.Alto2 = 0;
    }

    validarExistencias(): boolean {
        let ret = false;

        return ret;
    }
}
